import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnvelopeRegularUserIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.3 6.4a3 3 0 0 0-3.1 3.2v12.8c0 1.8 1.4 3.2 3.2 3.2h9.7q-.6-1.2-.8-2.4H6.4a1 1 0 0 1-.8-.8v-9.6l7.7 5.9q1 .7 2.1.8.3-1.2.9-2.3-.7 0-1.5-.4l-9-6.8-.2-.5q0-.6.7-.7h19.3q.7.1.8.8v2.5q1.2.3 2.4.8V9.6c0-1.8-1.4-3.2-3.2-3.2zM32 21.6a7.2 7.2 0 1 0-14.4 0 7.2 7.2 0 0 0 14.4 0m-3.3 4a5.6 5.6 0 0 1-7.8 0q.5-1.6 2.3-1.6h3.2q1.7.1 2.3 1.6M22.4 20a2.4 2.4 0 1 1 4.8 0 2.4 2.4 0 0 1-4.8 0" })
});
export default SvgEnvelopeRegularUserIcon;
